 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Pages-Authentication-AssignPassword-AssignPassword-vue":"Pages-Authentication-AssignPassword-AssignPassword-vue","Pages-Authentication-ForgotPassword-ForgotPassword-vue":"Pages-Authentication-ForgotPassword-ForgotPassword-vue","Pages-Authentication-ForgotPassword-Partials-SendOtp-vue":"Pages-Authentication-ForgotPassword-Partials-SendOtp-vue","Pages-Authentication-Login-Login-vue":"Pages-Authentication-Login-Login-vue","Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b":"Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b","Pages-Companies-Companies-vue":"Pages-Companies-Companies-vue","Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8":"Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8","Pages-DashboardCall-DashBoardCallUser-vue":"Pages-DashboardCall-DashBoardCallUser-vue","Pages-DashboardCall-DashboardCall-vue":"Pages-DashboardCall-DashboardCall-vue","Pages-Groups-GroupsDialog-vue":"Pages-Groups-GroupsDialog-vue","Pages-Groups-Groups-vue":"Pages-Groups-Groups-vue","Pages-Nodes-ImportNodesDialog-vue":"Pages-Nodes-ImportNodesDialog-vue","Pages-Nodes-Nodes-vue":"Pages-Nodes-Nodes-vue","Pages-Offices-Offices-vue":"Pages-Offices-Offices-vue","Pages-Users-UsersDialog-vue":"Pages-Users-UsersDialog-vue","Pages-Users-Users-vue":"Pages-Users-Users-vue","Pages-Companies-CompanyDialog-vue":"Pages-Companies-CompanyDialog-vue","Pages-Companies-CompanyExpansion-vue":"Pages-Companies-CompanyExpansion-vue","Pages-DashboardCall-DashBoardCallFilterUser-vue":"Pages-DashboardCall-DashBoardCallFilterUser-vue","Pages-DashboardCall-DashBoardCallFilters-vue":"Pages-DashboardCall-DashBoardCallFilters-vue","Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1":"Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1","Pages-Dashboards-DashboardFilters-vue":"Pages-Dashboards-DashboardFilters-vue","Pages-Dashboards-DashboardBase-vue":"Pages-Dashboards-DashboardBase-vue","Pages-Reports-ReportFilters-vue":"Pages-Reports-ReportFilters-vue","Pages-Reports-Reports-vue":"Pages-Reports-Reports-vue","Vusenavs":"Vusenavs","Pages-Errors-Error404-vue":"Pages-Errors-Error404-vue","Pages-Main-vue":"Pages-Main-vue","Pages-Nodes-NodesDialog-vue":"Pages-Nodes-NodesDialog-vue","Pages-Nodes-NodesExpansion-vue":"Pages-Nodes-NodesExpansion-vue","Pages-Offices-OfficeDialog-vue":"Pages-Offices-OfficeDialog-vue","Pages-Queues-Queues-vue":"Pages-Queues-Queues-vue","Pages-Users-UsersExpansion-vue":"Pages-Users-UsersExpansion-vue","Pages-Authentication-AssignPassword-Partials-ResetPassword-vue":"Pages-Authentication-AssignPassword-Partials-ResetPassword-vue"}[chunkId]||chunkId) + "." + {"Pages-Authentication-AssignPassword-AssignPassword-vue":"8f5a9853","Pages-Authentication-ForgotPassword-ForgotPassword-vue":"0794826e","Pages-Authentication-ForgotPassword-Partials-SendOtp-vue":"c69a1861","Pages-Authentication-Login-Login-vue":"e121bf8c","Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b":"8fd1554b","Pages-Companies-Companies-vue":"d55cea3a","Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8":"8c426cd2","Pages-DashboardCall-DashBoardCallUser-vue":"945ecf33","Pages-DashboardCall-DashboardCall-vue":"f6bcfb2c","Pages-Groups-GroupsDialog-vue":"cce22bb1","Pages-Groups-Groups-vue":"69f607c7","Pages-Nodes-ImportNodesDialog-vue":"24f8ea2f","Pages-Nodes-Nodes-vue":"a2b5822b","Pages-Offices-Offices-vue":"dbeb56d6","Pages-Users-UsersDialog-vue":"0ff99da4","Pages-Users-Users-vue":"1a7468a8","Pages-Companies-CompanyDialog-vue":"1cd01361","Pages-Companies-CompanyExpansion-vue":"4a723eae","Pages-DashboardCall-DashBoardCallFilterUser-vue":"af63d8dd","Pages-DashboardCall-DashBoardCallFilters-vue":"8963fd08","Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1":"3cc88083","Pages-Dashboards-DashboardFilters-vue":"8e532057","Pages-Dashboards-DashboardBase-vue":"a0f1a7a2","Pages-Reports-ReportFilters-vue":"cf204cb8","Pages-Reports-Reports-vue":"9dcd7e3b","Vusenavs":"19ad2c1a","Pages-Errors-Error404-vue":"884820d4","Pages-Main-vue":"fdbe162b","Pages-Nodes-NodesDialog-vue":"03291e26","Pages-Nodes-NodesExpansion-vue":"f28367e3","Pages-Offices-OfficeDialog-vue":"62f6cd36","Pages-Queues-Queues-vue":"a5f2b433","Pages-Users-UsersExpansion-vue":"e48979e1","chunk-50fc1479":"b19337b0","Pages-Authentication-AssignPassword-Partials-ResetPassword-vue":"5ede9f91"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Pages-Authentication-Login-Login-vue":1,"Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b":1,"Pages-Companies-Companies-vue":1,"Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8":1,"Pages-DashboardCall-DashBoardCallUser-vue":1,"Pages-DashboardCall-DashboardCall-vue":1,"Pages-Groups-GroupsDialog-vue":1,"Pages-Groups-Groups-vue":1,"Pages-Nodes-ImportNodesDialog-vue":1,"Pages-Nodes-Nodes-vue":1,"Pages-Offices-Offices-vue":1,"Pages-Users-UsersDialog-vue":1,"Pages-Users-Users-vue":1,"Pages-Companies-CompanyExpansion-vue":1,"Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1":1,"Pages-Dashboards-DashboardFilters-vue":1,"Pages-Dashboards-DashboardBase-vue":1,"Pages-Reports-ReportFilters-vue":1,"Vusenavs":1,"Pages-Main-vue":1,"Pages-Queues-Queues-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Pages-Authentication-AssignPassword-AssignPassword-vue":"Pages-Authentication-AssignPassword-AssignPassword-vue","Pages-Authentication-ForgotPassword-ForgotPassword-vue":"Pages-Authentication-ForgotPassword-ForgotPassword-vue","Pages-Authentication-ForgotPassword-Partials-SendOtp-vue":"Pages-Authentication-ForgotPassword-Partials-SendOtp-vue","Pages-Authentication-Login-Login-vue":"Pages-Authentication-Login-Login-vue","Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b":"Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b","Pages-Companies-Companies-vue":"Pages-Companies-Companies-vue","Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8":"Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8","Pages-DashboardCall-DashBoardCallUser-vue":"Pages-DashboardCall-DashBoardCallUser-vue","Pages-DashboardCall-DashboardCall-vue":"Pages-DashboardCall-DashboardCall-vue","Pages-Groups-GroupsDialog-vue":"Pages-Groups-GroupsDialog-vue","Pages-Groups-Groups-vue":"Pages-Groups-Groups-vue","Pages-Nodes-ImportNodesDialog-vue":"Pages-Nodes-ImportNodesDialog-vue","Pages-Nodes-Nodes-vue":"Pages-Nodes-Nodes-vue","Pages-Offices-Offices-vue":"Pages-Offices-Offices-vue","Pages-Users-UsersDialog-vue":"Pages-Users-UsersDialog-vue","Pages-Users-Users-vue":"Pages-Users-Users-vue","Pages-Companies-CompanyDialog-vue":"Pages-Companies-CompanyDialog-vue","Pages-Companies-CompanyExpansion-vue":"Pages-Companies-CompanyExpansion-vue","Pages-DashboardCall-DashBoardCallFilterUser-vue":"Pages-DashboardCall-DashBoardCallFilterUser-vue","Pages-DashboardCall-DashBoardCallFilters-vue":"Pages-DashboardCall-DashBoardCallFilters-vue","Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1":"Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1","Pages-Dashboards-DashboardFilters-vue":"Pages-Dashboards-DashboardFilters-vue","Pages-Dashboards-DashboardBase-vue":"Pages-Dashboards-DashboardBase-vue","Pages-Reports-ReportFilters-vue":"Pages-Reports-ReportFilters-vue","Pages-Reports-Reports-vue":"Pages-Reports-Reports-vue","Vusenavs":"Vusenavs","Pages-Errors-Error404-vue":"Pages-Errors-Error404-vue","Pages-Main-vue":"Pages-Main-vue","Pages-Nodes-NodesDialog-vue":"Pages-Nodes-NodesDialog-vue","Pages-Nodes-NodesExpansion-vue":"Pages-Nodes-NodesExpansion-vue","Pages-Offices-OfficeDialog-vue":"Pages-Offices-OfficeDialog-vue","Pages-Queues-Queues-vue":"Pages-Queues-Queues-vue","Pages-Users-UsersExpansion-vue":"Pages-Users-UsersExpansion-vue","Pages-Authentication-AssignPassword-Partials-ResetPassword-vue":"Pages-Authentication-AssignPassword-Partials-ResetPassword-vue"}[chunkId]||chunkId) + "." + {"Pages-Authentication-AssignPassword-AssignPassword-vue":"31d6cfe0","Pages-Authentication-ForgotPassword-ForgotPassword-vue":"31d6cfe0","Pages-Authentication-ForgotPassword-Partials-SendOtp-vue":"31d6cfe0","Pages-Authentication-Login-Login-vue":"69cd64fe","Pages-Companies-Companies-vue~Pages-DashboardCall-DashBoardCallUser-vue~Pages-DashboardCall-Dashboar~1e661c8b":"18bc4a4a","Pages-Companies-Companies-vue":"b327126c","Pages-DashboardCall-DashBoardCallFilterUser-vue~Pages-DashboardCall-DashBoardCallFilters-vue~Pages-D~dde48ce8":"6aa76c4d","Pages-DashboardCall-DashBoardCallUser-vue":"19ec3c3e","Pages-DashboardCall-DashboardCall-vue":"d933f95a","Pages-Groups-GroupsDialog-vue":"ca18c5f5","Pages-Groups-Groups-vue":"3ab7a86c","Pages-Nodes-ImportNodesDialog-vue":"663f8951","Pages-Nodes-Nodes-vue":"6d0e909e","Pages-Offices-Offices-vue":"fa1ed636","Pages-Users-UsersDialog-vue":"de6f792e","Pages-Users-Users-vue":"3ab7a86c","Pages-Companies-CompanyDialog-vue":"31d6cfe0","Pages-Companies-CompanyExpansion-vue":"6eda853a","Pages-DashboardCall-DashBoardCallFilterUser-vue":"31d6cfe0","Pages-DashboardCall-DashBoardCallFilters-vue":"31d6cfe0","Pages-Dashboards-DashboardBase-vue~Pages-Dashboards-DashboardFilters-vue~Pages-Reports-ReportFilters~2e5ebbe1":"3ab7a86c","Pages-Dashboards-DashboardFilters-vue":"f4b5d416","Pages-Dashboards-DashboardBase-vue":"f972735d","Pages-Reports-ReportFilters-vue":"cb0e817b","Pages-Reports-Reports-vue":"31d6cfe0","Vusenavs":"8fe19e61","Pages-Errors-Error404-vue":"31d6cfe0","Pages-Main-vue":"9ec4f6bb","Pages-Nodes-NodesDialog-vue":"31d6cfe0","Pages-Nodes-NodesExpansion-vue":"31d6cfe0","Pages-Offices-OfficeDialog-vue":"31d6cfe0","Pages-Queues-Queues-vue":"ae6917a3","Pages-Users-UsersExpansion-vue":"31d6cfe0","chunk-50fc1479":"31d6cfe0","Pages-Authentication-AssignPassword-Partials-ResetPassword-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
